import React, { FunctionComponent } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Unity from '../pages/Unity';
import IframeExample from '../pages/IframeExample';

export type AppProps = Record<string, never>;

const App: FunctionComponent<AppProps> = () => (
  <Router>
    <Switch>
      <Route exact path="/iframe-example" component={IframeExample} />
      <Route component={Unity} />
    </Switch>
  </Router>
);
export default App;
